require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-ankle-or-hip.json") })
        }
      }, "path---blog-ankle-or-hip");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-ankle-or-hip!./.cache/json/blog-ankle-or-hip.json
// module id = 275
// module chunks = 231608221292675